import { lazy, Suspense, type ReactElement } from 'react'

import { Loader } from '../components/Loader'

const LazyForgotPassword = lazy(() =>
  import('../pages/ForgotPassword/ForgotPassword').then((module) => ({ default: module.ForgotPassword })),
)

export const ForgotPasswordRoute = (): ReactElement => {
  return (
    <Suspense fallback={<Loader />}>
      <LazyForgotPassword />
    </Suspense>
  )
}
